import playWhite from "@assets/actions/play-white.svg";
import { twMerge } from "tailwind-merge";

export type ThumbnailProps = {
  src?: string;
  height?: string;
};

export default function Thumbnail({ src, height }: ThumbnailProps) {
  return (
    <div
      className={twMerge(
        `relative w-full rounded-thumbnail overflow-hidden h-[150px]`,
        height,
      )}
    >
      <div className="absolute inset-0 bg-grey-930 z-10"></div>
      <img
        src={src}
        alt="placehold"
        className="object-cover w-full h-full rounded-thumbnail z-20"
      />
      <div className="absolute inset-0 flex items-center justify-center z-20">
        <img className="h-[42px]" src={playWhite} alt="play-white-button" />
      </div>
    </div>
  );
}
